module.exports = __webpack_public_path__ + "media/images/logos/microsoft_teams-0887534ccaffb496be08f9ade3ac254b.png";